<template>
    <el-dialog title="Single-account CBR Calculator"
               width="1100px"
               top="50px"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <el-row>
            <el-col :span="4">
                <label>Include Lead Types</label>
            </el-col>    
            <el-col :span="8">
                <el-checkbox v-model="formData.include_mc" @change="refresh()">MC</el-checkbox>
                <el-checkbox v-model="formData.include_job_board" @change="refresh()">Job Board</el-checkbox>
                <el-checkbox v-model="formData.include_job_adviser" @change="refresh()">Job Adviser</el-checkbox>
            </el-col>    
        </el-row>
        <el-row class="mt-10">
            <el-col :span="4">
                <label>Cap increase at</label>
            </el-col>    
            <el-col :span="8">
                <input type="number" v-model="formData.cap_increase" @change="refresh()" /> %
            </el-col>
        </el-row>

        <div class="mt-10" v-loading="loading">
            <el-input type="textarea" v-model="formData.body" rows="20"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="send()">Send email to myself</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'selected_employers',
    ],
    data() {
        return {
            formData : {
                include_mc: true,
                include_job_board: true,
                include_job_adviser: true,
                cap_increase: 30,
                body: '',
            },
            loading: false,
        };
    },
    watch: {
        show() {
            if (this.show) {
                this.refresh();
            }
        }
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.post(url(`admin/estimates/send-cbr/single-account/data`), {
                employer_ids: this.selected_employers,
                include_mc: this.formData.include_mc,
                include_job_board: this.formData.include_job_board,
                include_job_adviser: this.formData.include_job_adviser,
                cap_increase: this.formData.cap_increase,
            }).then(response => {
                this.formData.body = response.data.body;
                this.loading = false;
            })
        },
        send() {
            return axios.post(url(`admin/estimates/send-cbr/single-account/send-email`), {
                data: this.formData,
            }).then(response => {
                this.$message.success(`Email sent to ${response.data.send_to}`);
            })
        }
    },
}
</script>
